import { gql } from "@apollo/client"

export const ALL_COUNTRIES = gql`
  query allCountrys {
    allCountrys(paginate: 20, orderBy: sortOrder_ASC) {
      name
      id
    }
  }
`

export const ALL_REGIONS = gql`
  query allRegions($countryId: Int!) {
    allRegions(paginate: 1000, filter: { countryId: $countryId }, orderBy: sortOrder_ASC) {
      fullName
      id
    }
  }
`

export const ALL_REGIONS_LIST = gql`
  query allRegions {
    allRegions(paginate: 1000, orderBy: sortOrder_ASC) {
      name
      fullName
      id
    }
  }
`

export const ALL_LOCATIONS = gql`
  query allLocations(
    $paginate: Int
    $filter: LocationFilterFilter
    $orderBy: LocationFilterOrderBy
  ) {
    allLocations(paginate: $paginate, filter: $filter, orderBy: $orderBy) {
      name
      id
    }
  }
`
